import { useEffect, useState, useCallback } from "react";
import api, { money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HOURS = Array.from({ length: 15 }, (_, i) => 7 + i); // 07:00 - 21:00

export default function Agenda() {
  const today = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; })();
  const [date, setDate] = useState(today);
  const [barbers, setBarbers] = useState([]);
  const [barberId, setBarberId] = useState("all");
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    const params = { date };
    if (barberId !== "all") params.barber_id = barberId;
    api.get("/appointments", { params }).then((r) => setItems((r.data || []).filter((a) => a.status !== "cancelled")));
  }, [date, barberId]);

  useEffect(() => { api.get("/barbers").then((r) => setBarbers(r.data || [])); }, []);
  useEffect(() => { load(); }, [load]);

  const toMin = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
  const startMin = HOURS[0] * 60;

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">Agenda</h1>
          <p className="text-zinc-400 mt-1">Visualize os horários ocupados por barbeiro.</p>
        </div>
        <div className="flex gap-3">
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="bg-zinc-900 border-zinc-700 w-44" data-testid="agenda-date" />
          <Select value={barberId} onValueChange={setBarberId}>
            <SelectTrigger className="bg-zinc-900 border-zinc-700 w-44" data-testid="agenda-barber"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Todos barbeiros</SelectItem>{barbers.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4 overflow-x-auto">
        <div className="relative min-w-[500px]" style={{ height: HOURS.length * 60 }}>
          {HOURS.map((h, i) => (
            <div key={h} className="absolute left-0 right-0 border-t border-zinc-800 flex" style={{ top: i * 60 }}>
              <span className="text-xs text-zinc-500 w-14 -mt-2">{String(h).padStart(2, "0")}:00</span>
            </div>
          ))}
          <div className="absolute left-16 right-2 top-0 bottom-0">
            {items.map((a) => {
              const top = toMin(a.start_time) - startMin;
              const height = Math.max(toMin(a.end_time) - toMin(a.start_time), 24);
              return (
                <div key={a.id} className="absolute left-0 right-0 bg-amber-500/15 border-l-4 border-amber-400 rounded-r-lg px-3 py-1 overflow-hidden" style={{ top, height }} data-testid={`agenda-block-${a.id}`}>
                  <div className="text-xs font-bold text-amber-300">{a.start_time} · {a.client_name}</div>
                  <div className="text-[11px] text-zinc-400 truncate">{a.service_name} • {a.barber_name} • {money(a.price)}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {items.length === 0 && <p className="text-center text-zinc-500 mt-4">Nenhum horário ocupado nesta data.</p>}
    </div>
  );
}
